import React from "react";
import InitialsAvatar from "../../../components/initials-avatar/InitialsAvatar";
import { TrashCanFileIcon } from "../../../../../assets/icons";
import Can from "../../../../../guards/Can";
import { CustomerPermissions } from "../../../../../model/permissions/permissions";
import styles from "./unlink-meter-row.module.scss";

interface UnlinkMeterRowProps {
	index: number;
	name: string;
	number: string;
	onUnlink: () => void;
	onClick?: () => void;
	isLast?: boolean;
}

export const UnlinkMeterRow: React.FC<UnlinkMeterRowProps> = ({ index, name, number, onUnlink, onClick, isLast = false }) => {
	const isClickable = onClick != null;

	const handleUnlink = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		onUnlink();
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
		if (!isClickable) return;
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			onClick?.();
		}
	};

	return (
		<div
			className={`${styles.row} ${isLast ? styles.last : ""} ${isClickable ? styles.clickable : ""}`}
			onClick={onClick}
			onKeyDown={handleKeyDown}
			role={isClickable ? "button" : undefined}
			tabIndex={isClickable ? 0 : undefined}
		>
			<InitialsAvatar name={name} index={index} size={40} fontSize={14} />
			<div className={styles.info}>
				<span className={styles.name}>{name}</span>
				<span className={styles.number}>{number}</span>
			</div>
			<Can permission={CustomerPermissions.UnlinkMeter}>
				<button type="button" className={styles.unlinkButton} onClick={handleUnlink} aria-label={`Remove ${name}`}>
					<TrashCanFileIcon width={16} height={16} color="var(--app-banner-error)" />
				</button>
			</Can>
		</div>
	);
};

export default UnlinkMeterRow;
